<script>
  import { fade } from 'svelte/transition'
  import {
    y,
    showLabelPage,
    posBeforeLabel,
    posBeforeBuy,
    calledFromLabel,
    showSpecimenPage,
  } from './stores.js'
  import { HOME } from './data/sections.js'
  import Nav from './components/nav.svelte'
  import Section from './components/section.svelte'
  import Labels from './components/sections/labels.svelte'
  import SpecimensGallery from './components/sections/specimensGallery.svelte'
  import Footer from './components/sections/Footer.svelte'

  let name = 'Arteria'
  let sections = [HOME, ...HOME.content.item_list]

  function handle_close(caller) {
    switch (caller) {
      case 'nav':
        requestAnimationFrame(() => {
          window.scrollTo(0, $posBeforeBuy)
        })
        break
      case 'label':
        showLabelPage.set(false)
        calledFromLabel.set(null)
        requestAnimationFrame(() => {
          window.scrollTo(0, $posBeforeLabel)
        })
        break
      case 'specimen':
        showSpecimenPage.set(false)
        calledFromLabel.set(null)
        requestAnimationFrame(() => {
          window.scrollTo(0, $posBeforeLabel)
        })
        break
    }
  }

  let innerHeight
  $: innerHeight = innerHeight
</script>

<svelte:window bind:scrollY={$y} bind:innerHeight />
<Nav
  {name}
  on:close={() => {
    handle_close('nav')
  }}
  on:closeLabels={() => {
    handle_close('label')
  }}
  on:closeSpecimens={() => {
    handle_close('specimen')
  }} />
<main>
  {#if $showLabelPage}
    <div transition:fade class="label-container">
      <Labels
        on:close={() => {
          handle_close('label')
        }} />
    </div>
  {:else if $showSpecimenPage}
    <div
      class="specimen-container"
      transition:fade
      style="
             height: {innerHeight}px;
      ">
      <SpecimensGallery
        on:close={() => {
          handle_close('specimen')
        }} />
    </div>
  {:else}
    {#each sections as section, i}
      <Section {section} {i} id={section.name} />
    {/each}
    <Footer />
  {/if}
</main>

<style lang="scss">
  @import './responsive.scss';

  main {
    padding-top: 60px;
    min-width: 100vw;

    @include for-phone {
      padding-top: 40px;
    }
  }

  .specimen-container {
    margin-top: -60px;
    padding: 77px 3em 0 3em;
    background-color: var(--dark);
    height: 100vh;
    @include for-phone {
      padding: 77px 1em 0 1em;
    }
  }
</style>
